export default "__VITE_ASSET__CCkLxXTw__"